/*
 |-----------------------------------------------------------------------------
 | components/organisms/Articles/Articles.tsx
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 */

import { FC } from 'react';

import { chunk, filter, get, isEmpty, map } from 'lodash';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
// import { ray } from 'node-ray/web';

import Article from '@/molecules/Article';
import { fallback } from '@/utils/fallback';
import { useAppSelector } from '@/app/hooks';

import * as IArticles from './types';
import styles from './Articles.module.scss';
import { articlesSelector } from '@/features/articles';

const Alert = dynamic(() => import('@/molecules/Alert'));

const Articles: FC<IArticles.IProps> = ({
	categories,
	storybook,
	text,
	title,
}) => {
	// ray('Debug organism Articles:', {
	// 	categories: categories,
	// 	storybook: storybook,
	// 	text: text,
	// 	title: title,
	// }).purple();

	const classes = classNames(get(styles, 'block'));

	const articles = useAppSelector(articlesSelector);

	const filteredArticles = filter(articles, ({ node }) => {
		return !get(node, 'feature');
	});

	const chunkedArticles = chunk(filteredArticles, 4);

	if (isEmpty(articles)) {
		return (
			<Alert
				isDismissible
				text="There are currently no articles to view"
				variant="warning"
			/>
		);
	}

	return (
		<section className={classes}>
			<header className={get(styles, 'header')}>
				<h2 className="u-screen-reader">Articles</h2>
			</header>

			<div className={get(styles, 'main')}>
				{chunkedArticles && (
					<div className={get(styles, 'list')}>
						{map(chunkedArticles, chunk => {
							return map(chunk, ({ node }, index) => {
								const aos =
									(index + 1) % 2 === 0
										? 'fade-up-left'
										: 'fade-up-right';

								let variant;
								switch (index) {
									case 0:
										variant = 'brand1';
										break;
									case 1:
										variant = 'brand2';
										break;
									case 2:
										variant = 'brand3';
										break;
									case 3:
										variant = 'brand4';
										break;
								}

								return (
									<Article
										key={index}
										action={get(node, ['card', 'action'])}
										aos={storybook ? null : aos}
										path={`/news/${get(node, [
											'_sys',
											'filename',
										])}`}
										title={fallback(
											get(node, ['card', 'title']),
											get(node, 'title')
										)}
										variant={variant}
									/>
								);
							});
						})}
					</div>
				)}
			</div>
		</section>
	);
};

export default Articles;
